import React, { useState } from 'react';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';
import { Button } from 'react-bootstrap';
import { Tooltip } from 'react-tooltip';
import './Sidebar.scss';

const Sidebar = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`sidebar ${isSidebarOpen ? 'open' : 'collapsed'}`}>
      <Button
        variant="primary"
        id="toggle-sidebar-button"
        data-tip={isSidebarOpen ? "Hide sidebar" : "Expand sidebar"}
        className="toggle-sidebar-button"
        onClick={toggleSidebar}
      >
        {isSidebarOpen ? <BiChevronLeft /> : <BiChevronRight />}
      </Button>
      <Tooltip anchorId="toggle-sidebar-button" place="right" />
      <div className="sidebar-content">
        {children}
      </div>
    </div>
  );
};

export default Sidebar;
